import React, { useState } from 'react';

// import { useQuery } from '@tanstack/react-query';

import ReportService from '../../../../../../services/ReportService';
import downloadDocument from '../../../../../../helpers/downloadDocument';

import { useUiContext } from '../../../../../../context/UiContext';

export default function AccelerationPackage({ loanId, isLender, demandId }) {
  const [isDownloading, setIsDownloading] = useState(false);

  const { showToast } = useUiContext();

  const download = async () => {
    try {
      setIsDownloading(true);
      const accelerationPackage = isLender
        ? await ReportService.getDemandAccelerationPackage(demandId)
        : await ReportService.getAccelerationPackage(loanId);
      await downloadDocument(
        accelerationPackage.id,
        accelerationPackage.private_document.name || 'acceleration_package.pdf'
      );
    } catch (error) {
      console.log(error);
      showToast({
        text: error?.response?.data?.message || 'Something went wrong',
        type: 'error',
      });
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div className="flex flex-col gap-10">
      <button
        disabled={isDownloading}
        type="button"
        className="btn w-full bg-indigo-500 md:max-w-sm text-white font-bold py-2 px-4 rounded hover:bg-indigo-600"
        onClick={download}
      >
        {isLender ? 'Acceleration Package' : 'Generate'}
      </button>
    </div>
  );
}
